import { Stack } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
export function CourseProgressBar({ value, ...props }) {
    return React.createElement(CourseProgressBarStyle, { className: "CourseProgress" },
        React.createElement(LinearProgress, { className: "ProgressBar", variant: "determinate", value: value * 100, ...props }),
        React.createElement(Typography, { className: "ProgressValue", variant: "overline", color: "textSecondary" }, `${Math.round(value * 100)}%`));
}
const CourseProgressBarStyle = styled(Stack, {
    name: 'CourseProgressBar',
    slot: 'Root'
})(({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'stretch',
    gap: theme.spacing(1),
    '& .ProgressBar': {
        flexGrow: 1,
        borderRadius: '3px',
        height: '6px',
        [`&.${linearProgressClasses.root}`]: {
            backgroundColor: theme.palette.grey[400],
            [`& .${linearProgressClasses.bar}`]: {
                borderRadius: '3px',
                backgroundColor: theme.palette.grey[800]
            }
        }
    },
    '& .ProgressValue': {
        minWidth: '2rem',
        lineHeight: 1,
        textAlign: 'right',
        color: theme.palette.text.primary
    }
}));
//# sourceMappingURL=CourseProgressBar.js.map